import {getStore} from 'redux-stores/Store';
import {postJSONPromise} from 'util/Net';

import {RealtimeEncryptionKey, setEncryptionKeys} from './RealtimeEncryptionReduxActions';

export async function fetchRealtimeEncryptionKeys(channel: string): Promise<{
  pastKey: RealtimeEncryptionKey;
  currentKey: RealtimeEncryptionKey;
  nextKey: RealtimeEncryptionKey;
}> {
  const data = await postJSONPromise({
    url: `/1/api/realtime/${encodeURIComponent(channel)}:encryption-key`,
    data: {},
  });

  const pastKey = {
    id: data.pastKey.id,
    key: data.pastKey.key,
  };

  const currentKey = {
    id: data.currentKey.id,
    key: data.currentKey.key,
  };

  const nextKey = {
    id: data.nextKey.id,
    key: data.nextKey.key,
  };

  getStore().dispatch(setEncryptionKeys(channel, pastKey, currentKey, nextKey));
  return {pastKey, currentKey, nextKey};
}
